/**
 * What the installed app says for itself: the page shown when the server cannot be reached
 * (`offline/main.ts`, which has no Vue and so reads this slice directly) and the prompt that
 * offers a new version (`AppUpdatePrompt.vue`). Its Local data rows are `account.privacy.app`.
 */
export default {
	pwa: {
		offline: {
			title: "You are offline",
			message:
				"Notitia could not reach the server. Check your connection — this page tries again by itself as soon as you are back online.",
			retry: "Try again",
		},
		update: {
			available: "A new version of Notitia is available",
			reload: "Reload",
			dismiss: "Dismiss",
		},
	},
};
